export const I3GIS = "I3GIS"